export default [
  //incident
  {
    path: "/incident-and-request",
    name: "IncidentAndRequest",
    component: () => import("@/views/3pl/IncidentAndRequest/Index.vue"),
  },
  {
    path: "/incident/incident-details/:id",
    name: "IncidentDetails",
    component: () => import("@/views/3pl/IncidentAndRequest/Incident/IncidentDetails.vue"),
  },
  {
    path: "/incident/shippment-timeline/:id",
    name: "IncidentShippmentTimeline",
    component: () => import("@/views/3pl/IncidentAndRequest/Incident/ShippmentTimeline.vue"),
  },
  {
    path: "/incident/process-transload",
    name: "IncidentProcessTransload",
    component: () => import("@/views/3pl/IncidentAndRequest/Incident/ProcessTransload.vue"),
  },
  {
    path: "/incident/transload-and-deliver",
    name: "IncidentTransloadAndDeliver",
    component: () => import("@/views/3pl/IncidentAndRequest/Incident/Transload/TransloadAndDeliver.vue"),
  },
  {
    path: "/incident/split-transload-and-deliver",
    name: "IncidentSplitTransloadAndDeliver",
    component: () => import("@/views/3pl/IncidentAndRequest/Incident/Transload/SplitTransloadAndDeliver.vue"),
  },
  {
    path: "/incident/transload-and-returntobase",
    name: "IncidentTransloadAndReturnToBase",
    component: () => import("@/views/3pl/IncidentAndRequest/Incident/Transload/TransloadAndReturnToBase.vue"),
  },
  {
    path: "/request/request-details/:id",
    name: "RequestDetails",
    component: () => import("@/views/3pl/IncidentAndRequest/Request/RequestDetails.vue"),
  },
  {
    path: "/request/process-relief-vehicle",
    name: "RequestProcessReliefVehicle",
    component: () => import("@/views/3pl/IncidentAndRequest/Request/RequestDetails.vue"),
  },
  {
    path: "/request/process-incident-admin",
    name: "RequestProcessIncidentAdmin",
    component: () => import("@/views/3pl/IncidentAndRequest/Incident/IncidentAdmin.vue"),
  },
  {
    path: "/incident/process-transload-timeline",
    name: "ProcessTransloadTimeline",
    component: () => import("@/views/3pl/IncidentAndRequest/Incident/Transload/SplitTransloadTimeline.vue"),
  },
  {
    path: "/incident/process-transload-details",
    name: "ProcessTransloadDetails",
    component: () => import("@/views/3pl/IncidentAndRequest/Incident/Transload/SplitTransloadDetails.vue"),
  },
];
